import SearchPageActionsContent from "./SearchPageActionsContent";
import DataContainer from "components/utility/data-container/DataContainer";
import { Result, SearchEngine } from "@coveo/headless";

export type SearchPageActionsShareProps = {
	content?: string;
	copyConfirm?: string;
	copyLabel?: string;
	externalLinkTitle?: string;
	shareUrl?: string;
	title?: string;
	isDisable?: boolean;
	metaData?: string;
	theme?: string;
	isNormalShare?: boolean;
};

type SearchPageActionsDatasetProps = {
	hideShare?: string;
	hideFavorite?: string;
	hideDownload?: string;
	downloadUrl?: string;
	color?: "default" | "teal" | "yellow";
	isModule?: string;
	isContentPageTop?: string;
	id?: string;
	virtualId?: string;
	title?: string;
	isGlobalSearch?: string;
	guid?: string;
};

export type SearchPageActionsProps = {
	dataset: SearchPageActionsDatasetProps;
	data?: {
		share: SearchPageActionsShareProps;
	};
	headlessEngine?: SearchEngine;
	result?: Result;
};

const SearchPageActions = ({ dataset, headlessEngine, result }: SearchPageActionsProps) => {
	const { guid = "1234" } = dataset;
	return (
		<DataContainer data={`contentPageActionsData_${guid}`}>
			<SearchPageActionsContent dataset={dataset} headlessEngine={headlessEngine} result={result} />
		</DataContainer>
	);
};

export default SearchPageActions;
